var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderlineBuyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 8,
    viewBox: "0 0 47 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1987 3.30456C15.4834 3.30456 20.7696 2.4452 26.0702 2.34424C30.1727 2.26609 34.2559 2.04741 38.3623 2.04741C38.9034 2.04741 42.9731 1.81988 40.6146 2.3617C34.2641 3.8206 28.0893 5.50457 21.513 5.50457C16.6151 5.50457 11.7941 5.60943 6.91612 5.83631C5.52254 5.90113 4.06168 6.01176 2.67325 6.1506C1.39528 6.2784 2.20551 6.15795 2.90024 6.13314C7.23563 5.9783 11.6633 6.0173 15.9955 6.1506C19.1575 6.24789 22.2904 6.44743 25.459 6.44743C29.9998 6.44743 34.4999 5.81885 39.0432 5.81885C41.3086 5.81885 43.4786 5.50457 45.7131 5.50457",
    stroke: "#DFF9F8",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineBuyer);
export default __webpack_public_path__ + "static/media/underline-buyer.3d3ae4f146c3f234e87d668c33eec865.svg";
export { ForwardRef as ReactComponent };